export function getAppFromSource(product: string | null | undefined, url: string): string {
	if (product === 'Microsoft') {
		if (url.includes('sharepoint.com')) return 'sharepoint';
		if (url.includes('powerbi.com')) return 'power-bi';
		if (url.includes('teams.microsoft.com')) return 'teams';
	}
	return product ?? '';
}
